/* eslint-disable  */
//@ts-nocheck

'use strict';

import React from 'react';

import ajax from './ajax';
import helpers from './helpers';

class ButtonAddToLibrary extends React.Component {
  constructor(props) {
    super(props);
    this.states = {
      Default: 1,
      Saving: 2,
      Delete: 3,
      Deleting: 4,
    };
    this.state = {
      buttonState: this.states.Default,
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (this.state.buttonState == this.states.Default)
      this.createExerciseTemplate();
    if (this.state.buttonState == this.states.Delete)
      this.deleteExerciseTemplate();
  }

  createExerciseTemplate() {
    this.setState({ buttonState: this.states.Saving });
    if (!this.props.template.name) {
      this.props.statusBar.sendMessage(
        'Could not save exercise to Library, please make sure your exercise has a name.',
      );
      this.setState({ buttonState: this.states.Default });
      return;
    }
    ajax
      .upsertExerciseTemplate({
        influencerId: this.props.influencerId,
        template: helpers.prepareExercise(this.props.template),
      })
      .then((et) => {
        console.log('[ButtonAddToLibrary] Saved ExerciseTemplate.', et);
        this.setState({
          buttonState: this.states.Delete,
          exerciseTemplateId: et.id,
        });
      })
      .catch((e) => {
        console.log('[ButtonAddToLibrary] Error creating ExerciseTemplate.', e);
        this.setState({ buttonState: this.states.Default });
        if (!this.props.template.name) {
          this.props.statusBar.sendMessage(
            'Could not save exercise to Library, please make sure your exercise has a name.',
          );
        } else {
          this.props.statusBar.sendMessage(
            "You're experiencing connection issues, please try again.",
          );
        }
      });
  }

  deleteExerciseTemplate() {
    this.setState({ buttonState: this.states.Deleting });
    ajax
      .deleteExerciseTemplate(this.state.exerciseTemplateId)
      .then((et) => {
        console.log('[ButtonAddToLibrary] Deleted ExerciseTemplate.', et);
        this.setState({
          buttonState: this.states.Default,
          exerciseTemplateId: null,
        });
      })
      .catch((e) => {
        console.log(
          '[ButtonAddToLibrary] Error deleting exercise ExerciseTemplate.',
          e,
        );
        this.setState({ buttonState: this.states.Delete });
      });
  }

  render() {
    if (this.state.buttonState === this.states.Saving) {
      return (
        <div className="addToLibrary">
          <a onClick={this.onClick} className="actionLink button green-button">
            Saving...
          </a>
        </div>
      );
    } else if (this.state.buttonState === this.states.Delete) {
      return (
        <div className="addToLibrary">
          <a
            onClick={this.onClick}
            className="actionLink button green-button active"
          >
            Saved to library - <span className="underline">remove</span>
          </a>
        </div>
      );
    } else if (this.state.buttonState === this.states.Deleting) {
      return (
        <div className="addToLibrary">
          <a onClick={this.onClick} className="actionLink button green-button">
            Deleting...
          </a>
        </div>
      );
    }
    return (
      <div className="addToLibrary">
        <a onClick={this.onClick} className="actionLink button green-button">
          Save to library
        </a>
      </div>
    );
  }
}

export default ButtonAddToLibrary;
